<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      PCB(II) Arrears
    </h4>

    <v-row
      v-if="companyEmployee.pcb_arrears.length <1"
      class="mx-0"
    >
      <span class="mx-2"> No data available</span>
    </v-row>

    <v-row
      v-else
      class="mx-0"
      no-gutters
    >
      <v-col
        class="font-weight-bold text-center border-bottom-black border-right-black"
        cols="2"
      >
        DOE
      </v-col>
      <v-col class="font-weight-bold text-center border-bottom-black border-right-black">
        Month
      </v-col>
      <v-col
        class="font-weight-bold text-center border-bottom-black border-right-black"
        cols="2"
      >
        Year
      </v-col>
      <v-col
        class="font-weight-bold text-center border-bottom-black border-right-black"
        cols="2"
      >
        PCB Amount(RM)
      </v-col>

      <v-col
        class="font-weight-bold text-center border-bottom-black border-right-black"
        cols="2"
      >
        Receipt/Bank Slip/Transaction No.
      </v-col>

      <v-col
        class="font-weight-bold text-center border-bottom-black border-right-black"
        cols="2"
      >
        Transaction Date
      </v-col>

      <v-col class="border-bottom-black" />

      <v-col cols="12">
        <v-row
          v-for="pcbArrear in companyEmployee.pcb_arrears"
          :key="pcbArrear.id"
          no-gutters
          class="border-bottom-black"
        >
          <v-col
            cols="2"
            class="text-center border-right-black"
          >
            <v-tooltip
              bottom
              min-width="250"
            >
              <template v-slot:activator="{ on: tooltip }">
                <v-icon
                  small
                  color="info"
                  v-on="{ ...tooltip }"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Created by: <b>{{ pcbArrear.created_by }}</b> on <b>{{ $moment(pcbArrear.created_at).format('DD-MM-YYYY') }}</b></div>
              <div>Updated by: <b>{{ pcbArrear.updated_by }}</b> on <b>{{ $moment(pcbArrear.updated_at).format('DD-MM-YYYY') }}</b></div>
            </v-tooltip>
            {{ pcbArrear.deduction_or_earning.name }}
          </v-col>

          <v-col class="text-center border-right-black">
            {{ $moment(pcbArrear.payroll_period).format('MMM') }}
          </v-col>

          <v-col
            cols="2"
            class="text-center border-right-black"
          >
            {{ $moment(pcbArrear.payroll_period).format('Y') }}
          </v-col>

          <v-col
            cols="2"
            class="text-right border-right-black"
          >
            <span class="pr-1">{{ twoDigit(pcbArrear.pcb_amount) }}</span>
          </v-col>
          
          <v-col
            cols="2"
            class="text-center border-right-black"
          >
            {{ pcbArrear.pcb_receipt_no ? pcbArrear.pcb_receipt_no:'N/A' }}
          </v-col>

          <v-col
            cols="2"
            class="text-center border-right-black"
          >
            {{ pcbArrear.pcb_transaction_date ? pcbArrear.pcb_transaction_date:'N/A' }}
          </v-col>

          <v-col class="text-center">
            <employee-profile-payroll-payroll-company-pcb-arrear-dialog-edit
              v-if="!companyEmployee.end_date"
              :pcb-arrear="pcbArrear"
              @updated="$emit('load')"
            />
          </v-col>
        </v-row>
      </v-col> 
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyPcbArrearDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/pcb-arrear/DialogEdit'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    methods: {
      twoDigit (amount) {
        return (Math.round((amount / 100) * 100) / 100).toFixed(2)
      }, 
    },
  }
</script>

<style scoped>
.border{
  border-left:1px solid red;
}
.border-bottom-black{
  border-bottom:1px solid black
}
.border-right-black{
  border-right:1px solid black
}
</style>
